/**
 * Normaliza horário vindo do backend (ex.: {@code 20:00:00.0000000}) para {@code hh:mm}.
 */
export function formatarHoraSomenteHm(valor?: string | null): string {
  const s = valor?.trim();
  if (!s) {
    return '';
  }
  const m = /^(\d{1,2}):(\d{2})/.exec(s);
  if (!m) {
    return s;
  }
  const hh = Number(m[1]);
  const mm = Number(m[2]);
  if (!Number.isFinite(hh) || !Number.isFinite(mm)) {
    return s;
  }
  return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
}
